<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
            <div>
              <h4 class="text-primary">Pembelian</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">Pembelian</a>
                </li>
                <li class="breadcrumb-item active">
                  <span v-if="purchasing.id === null">New</span>
                  <span v-else>
                    {{ purchasing.purchasing_no }}
                  </span>
                </li>
              </ol>
              <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="sync-action" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Action</button>
              <div class="dropdown-menu" aria-labelledby="sync-action">
                <a class="dropdown-item" href="javascript:void(0)" @click="approve" v-show="authUser.permissions.purchasing_unlock">Approve</a>
                <a href="javascript:void(0)" class="dropdown-item" data-toggle="modal" data-target="#modalPurchasingRequestEdit" data-backdrop="static" data-keyboard="false">Request Edit</a>
                <a href="javascript:void(0)" class="dropdown-item" data-toggle="modal" data-target="#modalPurchasingRequestVoid" data-backdrop="static" data-keyboard="false">Request Delete</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="syncInventory">Sync Inventory</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="syncCOGS">Sync COGS</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="syncCOGSAll('reply')">Sync COGS All</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="syncOrderAll('reply')">Sync Order</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="syncOrder2('reply')">Sync Order New</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="setJournal('reply')">Post Journal</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="clearDetailCalc">Recalculate</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="removePurchasing('reply')" v-show="authUser.permissions.purchasing_delete">Delete</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="unlock" v-show="authUser.permissions.purchasing_unlock">Unlock</a>
              </div>
              <button type="button" @click="updatePurchasing" class="btn btn-sm btn-soft-primary pull-left" v-show="purchasing.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
              <button type="button" @click="createPurchasing" class="btn btn-sm btn-soft-primary pull-left" v-show="purchasing.id == null"><i class="fa fa-check" aria-hidden="true"></i> Create</button>
              <button type="button" @click="validate" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-check" aria-hidden="true"></i> Validate</button>
              <!-- <button type="button" class="btn btn-sm btn-hard-primary pull-left" v-if="purchasing.purchasing_no !== null">Post Bucket</button> -->
              <!-- <button type="button" class="btn btn-sm btn-hard-primary pull-left" v-if="purchasing.purchasing_no !== null">Sync Bucket</button> -->
              <button type="button" @click="approve" class="btn btn-sm btn-soft-outline-primary pull-left" v-if="purchasing.status === 'open'" v-show="authUser.permissions.purchasing_unlock">Approve</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- card1 -->
        <div :class="card1">
          <div class="card card-list">
            <div class="card-header">
              <div class="col-md-12">
                <h5 class="text-primary">
                  <span v-if="purchasing.id === null">New</span>
                  <span v-else>{{ purchasing.purchasing_no }}</span>
                  <span class="badge badge-primary ml-1" v-if="purchasing.status === 'order'">{{ purchasing.status }}</span>
                    <span class="badge badge-danger ml-1" v-else-if="purchasing.status === 'void'">{{ purchasing.status }}</span>
                    <span class="badge badge-success ml-1" v-else-if="purchasing.status === 'approve'">{{ purchasing.status }}</span>
                    <span class="badge badge-warning ml-1" v-else>{{ purchasing.status }}</span>
                </h5>
              </div>
            </div>
            <div class="card-body">
              <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
                <ul v-for="(a, index) in alert" :key="index">
                  <li v-html="a.message"></li>
                </ul>
              </div>
              <div class="row">
                  <div class="col-md-4">
                    <dl class="row dl-custom font-12">
                      <!-- <dt class="col-sm-4">Order No.</dt>
                      <dd class="col-md-8">
                        <span v-if="purchasing.lock">{{ purchasing.sp_no }}</span>
                        <input type="text" class="form-control form-control-lite" v-model="purchasing.sp_no" v-else/>
                      </dd> -->

                      <dt class="col-md-4">Invoice No.</dt>
                      <dd class="col-md-8">
                        <span v-if="purchasing.lock"><b>{{ purchasing.ext_no }}</b></span>
                        <input type="text" class="form-control form-control-lite" v-model="purchasing.ext_no" v-else />
                      </dd>

                      <dt class="col-md-4">Tanggal</dt>
                      <dd class="col-md-8">
                        <!-- <span v-if="purchasing.lock">{{ purchasing.purchasing_date | dateFormat('DD/MM/YYYY') }}</span> -->
                        <span v-if="purchasing.lock === true"><b>{{ purchasing.purchasing_date | dateFormat('DD/MM/YYYY') }}</b></span>
                        <span v-else>
                          <datetime v-model="purchasing.purchasing_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" v-if="authUser.permissions.purchasing_backdate"></datetime>
                          <datetime v-model="purchasing.purchasing_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" v-else :disabled="purchasing.lock" @input="checkDate"></datetime>
                        </span>
                      </dd>
                      <dt class="col-md-4">Faktur No.</dt>
                      <dd class="col-md-8">
                        <span v-if="purchasing.lock"><b>{{ purchasing.faktur_no }}</b></span>
                        <span v-else><input type="text" v-model="purchasing.faktur_no" class="form-control" /></span>
                      </dd>
                      <dt class="col-md-4">Faktur Date</dt>
                      <dd class="col-md-8">
                        <span v-if="purchasing.lock"><b>{{ purchasing.faktur_date | dateFormat('DD/MM/YYYY') }}</b></span>
                        <span v-else><datetime v-model="purchasing.faktur_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime></span>
                      </dd>
                      <dt class="col-md-4">Faktur Process Date</dt>
                      <dd class="col-md-8">
                        <span v-if="purchasing.lock"><b>{{ purchasing.faktur_process_date | dateFormat('DD/MM/YYYY') }}</b></span>
                        <span v-else><datetime v-model="purchasing.faktur_process_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime></span>
                      </dd>
                    </dl>
                  </div>
                  <div class="col-md-4">
                    <dl class="row dl-custom font-12">
                      <dt class="col-md-4">Vendor</dt>
                      <dd class="col-md-8">
                        <v-select class="vsc-custom" :options="vendorSelect" :reduce="vendor => vendor.meta.code" label="vendor" v-model="purchasing.vendor_no" :disabled="purchasing.lock"/>
                      </dd>

                      <dt class="col-md-4">Company</dt>
                      <dd class="col-md-8">
                        <span v-if="authUser.permissions.company_select_all">
                          <select v-model="purchasing.company_no" class="form-control form-control-lite" :disabled="purchasing.lock || purchasing.purchasing_no !== null" @change="setCompanyTax">
                            <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                          </select>
                        </span>
                        <span v-else>
                          {{ companyName }}
                        </span>
                      </dd>

                      <dt class="col-md-4">Tax</dt>
                      <dd class="col-md-8">
                        <select v-model="purchasing.tax_id" class="form-control form-control-lite" @change="setTax" :disabled="purchasing.lock">
                          <option v-for="t in taxList" :key="t.id" :value="t.id">{{ t.name }}</option>
                        </select>
                      </dd>

                      <dt class="col-md-4">Notes</dt>
                      <dd class="col-md-8">
                        <textarea class="form-control form-control-lite" v-model="purchasing.notes" rows="5" :disabled="purchasing.lock"></textarea>
                      </dd>
                    </dl>
                  </div>
                  <div class="col-md-4">
                    <strong class="font-14">Orders:</strong>
                    <span class="ml-2 font-16" style="cursor: pointer; color: #6FB56F" data-toggle="modal" data-target="#modalPurchasingOrderVendor" data-backdrop="static" data-keyboard="false" @click="getVendorOrder"><i class="fa fa-pencil"></i></span>
                    <ul v-for="(p, index) in purchasing.order" :key="p.id">
                      <li>
                        <span style="cursor: pointer; color: blue;" @click="getOrderNo(index)" data-toggle="modal" data-target="#modalPurchasingInventoryDetail" data-backdrop="static" data-keyboard="false">
                          {{ p.sp_no }}
                        </span>
                        - {{ p.purchasing_date | dateFormat('DD/MM/YYYY') }}
                        - <i>{{ p.purchasing_no }}</i>
                        <span class="ml-2 font-16" style="color: red; cursor: pointer" @click="removeOrder(index)" v-if="purchasing.lock !== true"><i class="fa fa-trash-o" aria-hidden="true"></i></span>
                      </li>
                    </ul>
                    <strong class="font-14">Inventory:</strong>
                    <span class="ml-2 font-16" style="cursor: pointer; color: #6FB56F" data-toggle="modal" data-target="#modalInventoryListApprove" data-backdrop="static" data-keyboard="false"  @click="getInventoryList"><i class="fa fa-pencil"></i></span>
                    <dl class="dl-custom row">
                      <dt class="col-md-4">Deliver Date</dt>
                      <dd class="col-md-8">
                        <span v-if="purchasing.lock === true">{{ purchasing.deliver_date | dateFormat('DD/MM/YYYY') }}</span>
                        <span v-else>
                          <datetime type="datetime" v-model="purchasing.deliver_date" class="form-control form-control-lite" value-zone="local" zone="local"  :disabled="purchasing.lock"></datetime>
                        </span>
                      </dd>
                    </dl>
                  </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-md-12">
                  <ul class="nav nav-tabs nav-bordered">
                    <li class="nav-item">
                      <a href="#details" data-toggle="tab" aria-expanded="false" class="nav-link active">Raw</a>
                    </li>
                    <li class="nav-item">
                      <a href="#general" data-toggle="tab" aria-expanded="false" class="nav-link">Summary</a>
                    </li>
                    <li class="nav-item">
                      <a href="#payment" data-toggle="tab" aria-expanded="false" class="nav-link">Payment</a>
                    </li>
                    <li class="nav-item">
                      <a href="#retur" data-toggle="tab" aria-expanded="false" class="nav-link">Retur</a>
                    </li>
                    <li class="nav-item">
                      <a href="#journal" data-toggle="tab" aria-expanded="false" class="nav-link">Journal</a>
                    </li>
                    <li class="nav-item">
                      <a href="#inventory" data-toggle="tab" aria-expanded="false" class="nav-link">Inventory</a>
                    </li>
                  </ul>
                  <div class="tab-content">
                    <div class="tab-pane" id="general">
                      <table class="table table-sm table-item table-hover table-striped">
                            <thead>
                                <th style="width: 35%">Product</th>
                                <th>Qty</th>
                                <th style="width: 10%">UoM</th>
                                <th>Price</th>
                                <th>Discount</th>
                                <th>(%)</th>
                                <th class="text-right">DPP</th>
                                <th class="text-right">Tax</th>
                                <th class="text-right">Total</th>
                                <th>#</th>
                            </thead>
                            <tbody>
                                <tr v-for="d in groupDetail" :key="d.id" >
                                  <td><b>[{{ d.product_no}}]</b> {{ d.description }}</td>
                                  <td>{{ d.qty }}</td>
                                  <td>{{ d.uom_id }}</td>
                                  <td>{{ d.price | currency }}</td>
                                  <td>{{ d.discount | currency }}</td>
                                  <td>{{ d.discount_percentage }} %</td>
                                  <td class="text-right">{{ d.subtotal | currency }}</td>
                                  <td class="text-right">{{ d.tax | currency }}</td>
                                  <td class="text-right">{{ d.total | currency }}</td>
                                  <td>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <!-- <span @click="addNewLine" class="link-secondary" v-if="purchasing.lock === false">+ Add Product</span> -->
                                  </td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colspan="8" class="text-right"><b>Subtotal</b></td>
                                <td class="text-right">{{ purchasing.subtotal | currency }}</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="8" class="text-right"><b>Discount</b></td>
                                <td class="text-right">({{ purchasing.discount | currency }})</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="8" class="text-right"><b>Delivery Cost</b></td>
                                <td class="text-right">
                                  {{ purchasing.delivery_cost | currency }}
                                </td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="8" class="text-right"><b>Tax</b></td>
                                <td class="text-right">
                                  <span class="mt-1" v-if="purchasing.tax !== 0" style="color: blue">
                                    <i>{{ purchasing.tax | currency }}</i>
                                  </span>
                                </td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="9"></td>
                              </tr>
                              <tr>
                                <td colspan="8" class="text-right"><b>Total</b></td>
                                <td class="text-right">{{ purchasing.total | currency }}</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="8"></td>
                              </tr>
                              <tr>
                                <td colspan="8" class="text-right"><b><i style="color: blue">Paid:</i></b></td>
                                <td class="text-right">{{ getTotalPaid | currency }}</td>
                                <td></td>
                              </tr>
                            </tfoot>
                      </table>
                    </div>
                    <div class="tab-pane" id="payment">
                      <div class="table responsive">
                        <table class="table table-sm table-item table-hover">
                          <thead>
                            <th>Payment Group No.</th>
                            <th>Payment No.</th>
                            <th>Date</th>
                            <th>Method</th>
                            <th>Account</th>
                            <th>Notes</th>
                            <th class="text-right">Amount</th>
                            <th>#</th>
                          </thead>
                          <tbody>
                            <tr v-for="(p, index) in getPaymentDetail" :key="p.id">
                              <td><b>{{ p.group_no }}</b></td>
                              <td>{{ p.payment_no }}</td>
                              <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                              <td>{{ p.method }}</td>
                              <td>{{ p.account_code }} - {{ p.account }}</td>
                              <td>{{ p.notes }}</td>
                              <td class="text-right">{{ p.price | currency }}</td>
                              <td>
                                <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removePayment(index)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colspan="5"></td>
                              <td class="text-right"><b>Total Purchasing:</b></td>
                              <td class="text-right"><b>{{ this.purchasing.total | currency }}</b></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="5"></td>
                              <td class="text-right"><b>Total Retur:</b></td>
                              <td class="text-right"><b>({{ totalRetur | currency }})</b></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="5"></td>
                              <td class="text-right"><b>Total Payment:</b></td>
                              <td class="text-right"><b>({{ getTotalPaid | currency }})</b></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="5"></td>
                              <td class="text-right"><b>Outstanding:</b></td>
                              <td class="text-right"><b>{{ getOutstanding | currency }}</b></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="5"></td>
                              <td></td>
                              <td>
                                <button type="button" class="btn btn-sm btn-soft-primary pull-right" @click="paymentComplete" v-if="getOutstanding !== 0">Payment Complete</button>
                              </td>
                              <td></td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                    <div class="tab-pane" id="retur">
                      <div class="table responsive">
                        <table class="table table-sm table-item table-hover">
                          <thead>
                            <th>Return No</th>
                            <th>Date</th>
                            <th>Vendor</th>
                            <th class="text-right">Total</th>
                          </thead>
                          <tbody>
                            <tr v-for="r in purchasing.returns" :key="r.id">
                              <td><b>{{ r.return_no }}</b></td>
                              <td>{{ r.return_date | dateFormat('DD/MM/YYYY') }}</td>
                              <td>{{ r.vendor }}</td>
                              <td class="text-right">{{ r.total | currency }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="tab-pane" id="journal">
                      <table class="table table-sm table-item table-hover table-striped">
                        <thead>
                          <th>Journal Code</th>
                          <th>Date</th>
                          <th>Account Code</th>
                          <th>Remark</th>
                          <th class="text-right">Debit</th>
                          <th class="text-right">Credit</th>
                        </thead>
                        <tbody>
                          <tr v-for="j in purchasing.journals" :key="j.id">
                            <td>
                              <span v-if="j.level === 1">
                                <b>{{ j.journal_code }} - {{ j.journal_description }}</b>&nbsp;
                                <span class="badge badge-success" v-if="j.status === 'posted'">{{ j.status }}</span>
                                <span class="badge badge-warning" v-else-if="j.status === 'draft'">{{ j.status }}</span>
                              </span>
                              <span v-else></span>
                            </td>
                            <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                            <td><b>{{ j.account_code }} {{ j.account }}</b></td>
                            <td>{{ j.remark }}</td>
                            <td class="text-right">
                              <span v-if="j.level === 2">{{ j.debit | currency }}</span>
                              <span v-if="j.level === 3"><b>{{ j.debit | currency }}</b></span>
                              <span v-else></span>
                            </td>
                            <td class="text-right">
                              <span v-if="j.level === 2">{{ j.credit | currency }}</span>
                              <span v-if="j.level === 3"><b>{{ j.credit | currency }}</b></span>
                              <span v-else></span>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colspan="4" class="text-right"><h5><b>Balance</b></h5></td>
                            <td class="text-right"><h5><b>{{ totalJournalDebit | currency }}</b></h5></td>
                            <td class="text-right"><h5><b>{{ totalJournalCredit | currency }}</b></h5></td>
                          </tr>
                        </tfoot>
                      </table>
                      <div class="row">
                        <div class="col-md-12">
                          <button type="button" class="btn btn-sm btn-hard-primary float-right" @click="postJournal"><i class="fa fa-plane"></i> Post Journal</button>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" id="inventory">
                      <div class="table-responsive">
                        <table class="table table-sm table-item table-hover table-striped">
                          <thead>
                            <th>Inventory No.</th>
                            <th>Date</th>
                            <th>Product</th>
                            <th>Qty</th>
                            <th>Uom</th>
                            <th>COGS</th>
                          </thead>
                          <tbody>
                            <tr v-for="i in inventoryList" :key="i.id">
                              <td>{{ i.inventory_no }}</td>
                              <td>{{ i.inventory_date | dateFormat('DD/MM/YYYY') }}</td>
                              <td><b>[{{ i.product_no }}]</b> {{ i.product }}</td>
                              <td>{{ i.qty_done }}</td>
                              <td>{{ i.uom_id }}</td>
                              <td>{{ i.cost | currency }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="tab-pane active" id="details">
                      <div class="table-responsive">
                        <table class="table table-sm table-item table-hover table-striped">
                          <thead>
                            <th style="width: 30%" colspan="2">Product</th>
                            <th>Purchasing Order No.</th>
                            <th>Qty Order</th>
                            <th style="width: 10%">
                              <input type="checkbox" value="true" v-model="selectQty" @click="selectClickQty" :disabled="purchasing.lock"><i class="form-icon"></i> Qty</th>
                            <th style="width: 10%">Uom</th>
                            <th style="width: 10%" class="text-right">Price</th>
                            <th style="width: 10%" class="text-right">Discount</th>
                            <th style="width: 5%" class="text-right">%</th>
                            <th class="text-right">DPP</th>
                            <th class="text-right">Tax</th>
                            <th class="text-right" style="width: 10%">Total</th>
                            <th>#</th>
                          </thead>
                          <tbody>
                            <tr v-for="(d, index) in purchasing.details" :key="d.id">
                              <td>
                                <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="d.product_no" @input="setProduct(index)" :disabled="purchasing.lock"/>
                              </td>
                              <td>{{ d.description }}</td>
                              <td><b>{{ d.order_no }}</b></td>
                              <td>{{ d.qty_done }}</td>
                              <td>
                                <input class="form-control form-right" type="text" v-model="d.qty" v-on:keyup="calcRowTotal(index)" :disabled="purchasing.lock"/>
                              </td>
                              <td>
                                <select v-model="d.uom_id" class="form-control" disabled="disabled">
                                  <option v-for="(u, idx) in d.uomList" :key="idx" :value="u.id">{{ u.name }}</option>
                                </select>
                              </td>
                              <td class="text-right">
                                <input class="form-control form-right" type="text" id="price" v-model="d.price" v-money="money"  v-on:keyup="calcRowTotal(index)" :disabled="authUser.permissions.purchasing_price_input === false"/>
                              </td>
                              <td class="text-right">
                                <span v-if="settingDiscount === false">
                                  <input type="text" v-model="d.discount" class="form-control form-right" v-money="money" v-on:keyup="calcRowTotal(index)"/>
                                </span>
                                <span v-else>{{ d.discount | currency }}</span>
                              </td>
                              <td class="text-right">
                                <span v-if="settingDiscount === false">
                                  {{ d.discount_percentage }}
                                </span>
                                <span v-else>
                                  <input class="form-control form-right" type="text" id="discount" v-model="d.discount_percentage" v-on:keyup="calcRowTotal(index)" :disabled="purchasing.lock"/>
                                </span>
                              </td>
                              <td class="text-right">{{ d.subtotal | currency }}</td>
                              <td class="text-right">{{ d.tax | currency }}</td>
                              <td class="text-right"><b>{{ d.total | currency }}</b></td>
                              <td>
                                <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removeDetail(index)" :disabled="purchasing.lock" v-if="purchasing.lock === false"><i class="fa fa-trash" aria-hidden="true"></i></button>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="13">
                                <span v-show="authUser.permissions.purchasing_add_product_line">
                                  <span @click="addNewLine" class="link-secondary" v-if="purchasing.lock === false">+ Add Product</span>
                                </span>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                              <tr>
                                <td colspan="11" class="text-right"><b>Subtotal</b></td>
                                <td class="text-right">{{ purchasing.subtotal | currency }}</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="11" class="text-right"><b>Discount</b></td>
                                <td class="text-right">({{ purchasing.discount | currency }})</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="11" class="text-right"><b>Delivery Cost</b></td>
                                <td class="text-right">
                                  <span  v-if="purchasing.lock === true">{{ purchasing.delivery_cost | currency }}</span>
                                  <span v-else>
                                    <input type="text" v-model="purchasing.delivery_cost" v-money="money" class="form-control form-control-right" @keyup="setDeliverCost" />
                                  </span>
                                </td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="11" class="text-right"><b>Tax</b></td>
                                <td class="text-right">
                                  <span class="mt-1" v-if="purchasing.tax !== 0" style="color: blue">
                                    <i>{{ purchasing.tax | currency }}</i>
                                  </span>
                                </td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="11" class="text-right"><b>Total</b></td>
                                <td class="text-right">{{ purchasing.total | currency }}</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="11"></td>
                              </tr>
                              <tr>
                                <td colspan="11" class="text-right"><b><i style="color: blue">Paid:</i></b></td>
                                <td class="text-right">{{ getTotalPaid | currency }}</td>
                                <td></td>
                              </tr>
                            </tfoot>
                        </table>
                      </div>
                      <div class="row">
                        <!-- <div class="col-md-6"><pre>{{ authUser }}</pre></div> -->
                        <!-- <div class="col-md-6"><pre>{{ groupDetail }}</pre></div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
            </div>
          </div>
        </div>
        <!-- card2 -->
        <div :class="card2" v-if="card2 !== null">
          <div class="card card-list">
            <div class="card-header">
              <h5 class="text-primary">
                <span>Order List</span>
              </h5>
            </div>
            <div class="card-body">
              <input type="search" class="form-control" v-model="searchQueryOrder" placeholder="search..."/>
              <div class="table-responsive">
                <table class="table table-sm table-item table-hover table-striped">
                  <thead>
                    <th>Order No</th>
                    <th>Product No.</th>
                    <th>Product name</th>
                    <th>Qty Order</th>
                    <th>Qty Pembelian</th>
                    <th>Uom</th>
                  </thead>
                  <tbody>
                    <tr v-for="i in vendorOrderList" :key="i.id">
                      <td><b>{{ i.sp_no }}</b></td>
                      <!-- <td>{{ i.purchasing_date | dateFormat('DD/MM/YYYY') }}</td> -->
                      <td>{{ i.product_no }}</td>
                      <td>{{ i.product }}</td>
                      <td>{{ i.qty }}</td>
                      <td>{{ i.qty_done }}</td>
                      <td>{{ i.uom_id }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <PurchasingDetailModal :idDetail="idDetail" :purchasing="purchasing" @selectProduct="selectProduct" :amountDue="getTotal"/> -->
      <PurchasingInventoryModal @selectInventory="selectInventory" @selectOrderMulti="selectOrderMulti" :company="purchasing.company_no"/>
      <PurchasingRequestEditModal @getRequestEdit="requestEdit" @getRequestVoid="requestVoid"/>
      <InventoryListApproveModal :vendorNo="vendorNo" @selectInventoryAll="selectInventoryAll"/>
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in purchasing.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div>
      <!-- <pre>{{ totalJournalDebit }}</pre>
      <pre>{{ totalJournalCredit }}</pre>
      <pre>{{ journalLevel3 }}</pre> -->
      <!-- <pre>Setting Journal: {{ settingJournal }}</pre> -->
      <!-- <pre>{{ settingList }}</pre> -->
      <!-- <pre>{{ vendorSelect }}</pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { inventoryUrl, purchasingUrl, purchasingDetailUrl, setQtyTotalUrl, getHeader, salesUrl, productUrl, lockUrl, purchasingOrderUrl } from '../../config'
// import PurchasingDetailModal from '@/components/purchasing/PurchasingDetailModal.vue'
import PurchasingInventoryModal from '@/components/purchasing/PurchasingInventoryModal.vue'
import PurchasingRequestEditModal from '@/components/purchasing/PurchasingRequestEditModal.vue'
import InventoryListApproveModal from '@/components/inventory/InventoryListApproveModal.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'PurchasingForm',
  props: ['purchasing'],
  components: {
    // PurchasingDetailModal,
    PurchasingInventoryModal,
    PurchasingRequestEditModal,
    InventoryListApproveModal,
    Loading
  },
  data () {
    return {
      alert: [],
      vendorNo: null,
      inventoryData: {},
      selectQty: false,
      searchQueryInventory: '',
      searchQueryOrder: '',
      card1: 'col-md-12',
      card2: null,
      ref: null,
      refNo: null,
      idDetail: null,
      detail: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  created () {
    this.ref = this.$route.query.ref
    this.refNo = this.$route.query.refNo
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      branchList: state => state.branches.branchList,
      vendorList: state => state.vendors.vendorList,
      productListSelect: state => state.products.productListSelect,
      taxList: state => state.taxes.taxList,
      uomList: state => state.uom.uomList,
      paymentTypeList: (state) => state.payments.typeList,
      paymentMethodList: (state) => state.payments.methodList,
      paymentBankList: (state) => state.banks.bankList,
      purchasingTypeList: state => state.purchasingTypes.purchasingTypeList,
      termDueList: state => state.termduedates.termDueList,
      companyList: state => state.companies.companyList,
      warehouseList: state => state.warehouses.warehouseList,
      chartOfAccountList: state => state.accounts.chartOfAccountList,
      settingList: state => state.data.settingList
    }),
    journalLevel3 () {
      var array = this.purchasing.journals.filter(d => d.level === 3)
      var loop = []
      for (let i = 0; i < array.length; i++) {
        loop.push(array[i])
      }
      return loop
    },
    totalJournalCredit () {
      var array = this.journalLevel3
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].credit)
      }
      return sum
    },
    totalJournalDebit () {
      var array = this.journalLevel3
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].debit)
      }
      return sum
    },
    companyName () {
      const company = this.companyList.find(d => d.company_no === this.authUser.company_no)
      var companyName = null
      if (company) {
        companyName = company.name
      }
      return companyName
    },
    totalRetur () {
      var array = this.purchasing.returns
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    settingJournal () {
      var setting = this.settingList.find(d => d.name === 'set-journal-transaction' && d.company_no === this.authUser.company_no)
      if (setting) {
        return setting.active
      } else {
        return false
      }
    },
    settingDiscount () {
      var setting = this.settingList.find(d => d.name === 'purchasing_detail_discount_percentage' && d.company_no === this.authUser.company_no)
      if (setting) {
        return setting.active
      } else {
        return false
      }
    },
    settingTaxRound () {
      var setting = this.settingList.find(d => d.name === 'purchasing_tax_round' && d.company_no === this.authUser.company_no)
      if (setting) {
        return setting.active
      } else {
        return false
      }
    },
    groupDetail () {
      var result = []
      if (this.purchasing.details.length > 0) {
        this.purchasing.details.reduce(function (res, value) {
          // key = Date.parse(value.cost_date) + value.queue + value.company_no
          var key = value.product_no + value.price
          var price = parseFloat(value.price.replace(/\./g, ''))
          var qty = parseFloat(value.qty)
          var qtyDone = parseFloat(value.qty_done)
          var total = (parseFloat(value.subtotal) + parseFloat(value.tax)) * qty
          if (!res[key]) {
            res[key] = {
              product_no: value.product_no,
              description: value.description,
              price: price,
              qty: qty,
              qty_done: qtyDone,
              branch_no: value.branch_no,
              uom_id: value.uom_id,
              tax_id: value.tax_id,
              tax: value.tax,
              discount: value.discount,
              discount_percentage: value.discount_percentage,
              subtotal: value.subtotal,
              total: total,
              order_no: value.order_no,
              state: value.state,
              edit: value.edit,
              uomList: value.uomList
            }
            result.push(res[key])
          } else {
            res[key].qty = res[key].qty + qty
            res[key].qty_done = res[key].qty_done + qtyDone
            res[key].total = res[key].total + total
          }
          return res
        }, {})
      }
      // return result
      var col = 'date'
      var ascending = true
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return result.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    dataDetailCollect () {
      var loop = []
      var array = this.purchasing.details
      for (let i = 0; i < array.length; i++) {
        if (array[i].qty !== 0 || array[i].qty === null) {
          var obj = {}
          if (typeof array[i].id === 'undefined') {
            obj = {
              purchasing_no: array[i].purchasing_no,
              purchasing_date: array[i].purchasing_date,
              branch_no: array[i].branch_no,
              product_no: array[i].product_no,
              product_sku: array[i].product_sku,
              description: array[i].description,
              qty: array[i].qty,
              qty_done: array[i].qty_done,
              uom_id: array[i].uom_id,
              price: array[i].price.replace(/\./g, ''),
              tax_id: array[i].tax_id,
              tax: array[i].tax,
              discount: array[i].discount,
              total: array[i].total,
              company_no: array[i].company_no,
              vendor_no: array[i].vendor_no,
              discount_percentage: array[i].discount_percentage,
              subtotal: array[i].subtotal,
              order_no: array[i].order_no
            }
            loop.push(obj)
          } else {
            obj = {
              id: array[i].id,
              purchasing_no: array[i].purchasing_no,
              purchasing_date: array[i].purchasing_date,
              branch_no: array[i].branch_no,
              product_no: array[i].product_no,
              product_sku: array[i].product_sku,
              description: array[i].description,
              qty: array[i].qty,
              qty_done: array[i].qty_done,
              uom_id: array[i].uom_id,
              price: array[i].price.replace(/\./g, ''),
              tax_id: array[i].tax_id,
              tax: array[i].tax,
              discount: array[i].discount,
              total: array[i].total,
              company_no: array[i].company_no,
              vendor_no: array[i].vendor_no,
              discount_percentage: array[i].discount_percentage,
              subtotal: array[i].subtotal,
              order_no: array[i].order_no
            }
            loop.push(obj)
          }
        }
      }
      return loop
    },
    totalDetailSubtotal () {
      var sum = 0
      var array = this.purchasing.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.replace(/\./g, '')) * parseFloat(array[i].qty)
      }
      return sum
    },
    totalDetail () {
      var cost = parseFloat(this.purchasing.delivery_cost.replace(/\./g, ''))
      var sum = 0
      var array = this.purchasing.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum + cost
    },
    totalDetailTax () {
      var sum = 0
      var array = this.purchasing.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].tax)
      }
      // Total Tax
      return sum + this.totalDeliveryTax
    },
    totalDeliveryTax () {
      // Delivery
      const costDlv = this.purchasing.delivery_cost.replace(/\./g, '')
      var taxDlv = 0
      var dppDlv = 0
      var tax = this.taxList.find(d => d.id === this.purchasing.tax_id)
      if (tax.include === false) {
        taxDlv = costDlv * tax.amount / 100
      } else {
        if (tax.amount === '0') {
          taxDlv = 0
        } else {
          if (tax.amount === '11') {
            dppDlv = costDlv / 1.11
            taxDlv = costDlv - dppDlv
          } else {
            dppDlv = costDlv / 1.1
            taxDlv = costDlv - dppDlv
          }
        }
      }
      var fixTax = 0
      if (this.settingTaxRound) {
        fixTax = Math.round(taxDlv)
      } else {
        fixTax = taxDlv
      }
      return fixTax
    },
    totalDetailDiscount () {
      var sum = 0
      var array = this.purchasing.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].discount)
      }
      return sum
    },
    inventoryList () {
      var loop = []
      var array = this.purchasing.inventory
      for (let i = 0; i < array.length; i++) {
        var arrDetail = array[i].details
        for (let a = 0; a < arrDetail.length; a++) {
          loop.push({
            id: arrDetail[a].id,
            inventory_no: arrDetail[a].inventory_no,
            serial_number: arrDetail[a].serial_number,
            product_no: arrDetail[a].product_no,
            product: arrDetail[a].product,
            warehouse_no: arrDetail[a].warehouse_no,
            warehouse: arrDetail[a].warehouse,
            uom_id: arrDetail[a].uom_id,
            qty_demand: arrDetail[a].qty_demand,
            qty_done: arrDetail[a].qty_done,
            inventory_date: arrDetail[a].inventory_date,
            branch_no: arrDetail[a].branch_no,
            expired_date: arrDetail[a].expired_date,
            product_sku: arrDetail[a].product_sku,
            sec_serial_number: arrDetail[a].sec_serial_number,
            internal_no: arrDetail[a].internal_no,
            company_no: arrDetail[a].company_no,
            cost: arrDetail[a].cost,
            vendor_no: arrDetail[a].vendor_no,
            receive_finish: arrDetail[a].receive_finish
          })
        }
      }
      return loop
    },
    vendorOrderList () {
      var array = this.purchasing.order
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var arrDetail = array[i].details
        for (let a = 0; a < arrDetail.length; a++) {
          var obj = {
            id: arrDetail[a].id,
            purchasing_no: array[i].purchasing_no,
            purchasing_date: array[i].purchasing_date,
            sp_no: array[i].sp_no,
            product_no: arrDetail[a].product_no,
            product: arrDetail[a].product,
            qty: arrDetail[a].qty,
            qty_done: arrDetail[a].qty_done,
            uom_id: arrDetail[a].uom_id
          }
          loop.push(obj)
        }
      }
      return loop.filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQueryOrder.toLowerCase()) > -1) {
              return d
            }
          }
        }
      })
    },
    inventoryListDetail () {
      var loop = []
      var array = this.purchasing.inventory
      for (let i = 0; i < array.length; i++) {
        var detail = array[i].details
        if (detail.length > 0) {
          for (let a = 0; a < detail.length; a++) {
            var obj = {
              id: detail[a].id,
              inventory_no: array[i].inventory_no,
              inventory_date: array[i].inventory_date,
              product_no: detail[a].product_no,
              product: detail[a].product,
              qty_demand: detail[a].qty_demand,
              qty_done: detail[a].qty_done,
              uom_id: detail[a].uom_id
            }
            loop.push(obj)
          }
        }
      }
      return loop.filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQueryOrder.toLowerCase()) > -1) {
              return d
            }
          }
        }
      })
    },
    getPaymentDetail: function () {
      return this.purchasing.payment.filter(d => d.id !== null)
    },
    vendorSelect () {
      var loop = []
      var array = this.vendorList
      for (let i = 0; i < array.length; i++) {
        var obj = {
          vendor: array[i].vendor_no + ' - ' + array[i].name,
          meta: {
            code: array[i].vendor_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    productselect: function () {
      var loop = []
      var array = this.productListSelect
      for (var x = 0; x < array.length; x++) {
        var obj = {
          product: array[x].product_no,
          meta: {
            code: array[x].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    purchasingDetail: function () {
      return this.purchasing.details
    },
    getSubtotal: function () {
      var array = this.purchasing.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        // var price = isNaN(array[i].price) ? array[i].price : '0'
        var price = array[i].price
        sum += array[i].qty * parseFloat(price.replace(/\./g, ''))
      }
      return sum
    },
    getTax: function () {
      return 0
    },
    getTotal: function () {
      var subtotal = this.getSubtotal
      var discount = 0
      if (typeof this.purchasing.discount === 'string') {
        discount = parseFloat(this.purchasing.discount.replace(/\./g, ''))
      }
      var dCost = parseFloat(this.purchasing.delivery_cost.replace(/\./g, ''))
      var subtotal2 = subtotal - discount
      var total = parseFloat(subtotal2) + parseFloat(this.purchasing.tax) + dCost
      return total.toString()
    },
    getTotalPaid: function () {
      var sum = 0
      var array = this.purchasing.payment
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.replace(/\./g, ''))
      }
      return sum
    },
    getOutstanding () {
      var ost = 0
      ost = this.purchasing.total - this.totalRetur - this.getTotalPaid
      return ost
    },
    getPaidStatus: function () {
      var paid = this.getTotalPaid
      var total = this.getTotal
      if (paid >= total) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    async paymentComplete () {
      var obj = {
        payment_no: null,
        purchasing_no: this.purchasing.purchasing_no,
        payment_date: new Date().toISOString(),
        price: parseFloat(this.getOutstanding),
        method_id: null,
        type_id: null,
        bank_id: null,
        notes: '[pelunasan by system]',
        group_no: null,
        account_code: null,
        finish: true
      }
      console.log(obj)
      await axios.post(purchasingUrl + '/payment', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Success', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$emit('backClickID', this.purchasing.id)
    },
    async unlock () {
      var body = {
        id: this.purchasing.id
      }
      await this.$swal.fire({
        title: 'Are you sure unlock this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#28A745',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Unlock it!'
      }).then((result) => {
        if (result.value) {
          axios.post(purchasingUrl + '/unlock', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
              this.$swal('Success', response.data.message, 'success')
              this.$emit('backSaveChild')
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async checkDate () {
      var date1 = new Date()
      date1.setHours(0, 0, 0, 0)
      var date2 = new Date(this.purchasing.purchasing_date)
      date2.setHours(0, 0, 0, 0)
      var remaining = date2.getTime() - date1.getTime()
      var diffInDay = (Math.round(remaining / (1000 * 3600 * 24)))
      console.log('Diff in a day ' + diffInDay)
      if (diffInDay > 0) {
        this.$swal('Error', 'Tanggal tidak boleh lebih dari hari ini (' + diffInDay + ' hari)', 'error')
        this.purchasing.purchasing_date = date1.toISOString()
      } else if (Math.abs(diffInDay) > 2) {
        this.$swal('Error', 'Tanggal tidak boleh kurang dari 2 hari', 'error')
        this.purchasing.purchasing_date = date1.toISOString()
      }
    },
    async removePurchasing () {
      await this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$Progress.start()
          this.loader.isLoading = true
          axios.delete(purchasingUrl + '/' + this.purchasing.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              axios.get(inventoryUrl + '/clear-purchasing', { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
                .then(response => {
                  console.log(response.data.message)
                })
                .catch(error => {
                  console.log(error)
                  console.log(error.response)
                })
              this.$swal('Purchasing', 'Process Sync', 'success')
              this.syncOrderAll('no reply')
              this.syncCOGSAll()
              this.$Progress.finish()
              this.loader.isLoading = false
              this.$emit('backSaveChild')
            })
            .catch(error => {
              this.$Progress.finish()
              this.loader.isLoading = false
              console.log(error)
              console.log(error.response.data.message)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async selectInventoryAll (value) {
      this.purchasing.inventory = value
      this.purchasing.details = []
      for (let a = 0; a < value.length; a++) {
        console.log(value[a])
        var array = value[a].details
        for (let i = 0; i < array.length; i++) {
          var obj = {
            purchasing_no: null,
            purchasing_date: this.purchasing.purchasing_date,
            branch_no: this.purchasing.branch_no,
            product_no: array[i].product_no,
            product: array[i].product,
            description: array[i].product,
            qty: array[i].qty_done,
            qty_done: 0,
            uom_id: array[i].uom_id,
            price: '0',
            tax_id: null,
            tax: '0',
            discount: '0',
            subtotal: '0',
            total: '0',
            edit: false,
            uomList: [{
              id: null,
              name: null,
              ratio: '0',
              category: null
            }]
          }
          console.log('purchasing detail data:')
          console.log(obj)
          this.purchasing.details.push(obj)
        }
      }
      var arr = this.purchasing.details
      for (let i = 0; i < arr.length; i++) {
        this.setProduct(i)
      }
    },
    getInventoryList () {
      this.vendorNo = this.purchasing.vendor_no
      this.$store.dispatch('getInventoryApprove')
    },
    async syncOrderAll (reply) {
      if (reply === 'reply') {
        await this.$Progress.start()
        this.loader.isLoading = true
      }
      var array = this.purchasing.order
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].details
        for (let a = 0; a < arr.length; a++) {
          var obj = {
            product_no: arr[a].product_no,
            order_no: arr[a].purchasing_no,
            price: arr[a].price,
            uom_id: arr[a].uom_id
          }
          await axios.post(purchasingOrderUrl + '/sync-to-purchasing', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
              // var data = response.data.data
              // if (arr[a].product_no === data.product_no) {
              //   console.log(arr[a].product_no)
              //   var qtyPurchase = parseFloat(arr[a].qty)
              //   var qtyOrder = parseFloat(data.qty)
              //   var qtyOrderDone = parseFloat(data.qty_done)
              //   var qtyOrderRemaining = (qtyOrderDone - qtyPurchase) - qtyOrder
              //   if (qtyPurchase > qtyOrderRemaining) {
              //     this.alert.push(arr[a].product_no + ' Qty Order kurang dari pembelian: order (' + qtyOrderDone + ') ' + ' pembelian (' + qtyPurchase + ')')
              //   }
              // }
            })
            .catch(error => {
              console.log(error)
              console.log(error.response.data.message)
              this.alert.push(error.response.data.message)
            })
        }
      }
      if (reply === 'reply') {
        await this.$Progress.finish()
        this.loader.isLoading = false
      }
    },
    async syncOrder2 (reply) {
      await this.$Progress.start()
      this.loader.isLoading = true
      var array = this.dataDetailCollect
      for (let i = 0; i < array.length; i++) {
        var obj = {
          product_no: array[i].product_no,
          order_no: array[i].order_no,
          price: array[i].price.replace(),
          uom_id: array[i].uom_id
        }
        var resp = {
          error: false,
          message: null
        }
        console.log('syncOrder2')
        console.log(obj)
        await axios.post(purchasingOrderUrl + '/sync-to-purchasing', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$Progress.fail()
            this.loader.isLoading = false
            if (reply === 'reply') {
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            }
            resp.error = true
            resp.message = error.response.data.message
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      if (reply === 'reply') {
        if (resp.error === true) {
          await this.$swal('Error', resp.message, 'error')
        } else {
          await this.$swal('Success', resp.message, 'success')
        }
      }
    },
    async syncOrder () {
      var dataSync = {
        date: this.purchasing.purchasing_date,
        vendor_no: this.purchasing.vendor_no
      }
      await axios.post(purchasingUrl + '/order/sync-order', dataSync, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backParentID', this.purchasing.id)
        })
        .catch(error => {
          console.log(error)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
          return false
        })
    },
    setDeliverCost () {
      // var cost = parseFloat(this.purchasing.delivery_cost.replace(/\./g, ''))
      this.setTax()
      this.purchasing.total = this.totalDetail
    },
    setCompanyTax () {
      var company = this.companyList.find(d => d.company_no === this.purchasing.company_no)
      var taxid = company ? company.tax_id : null
      this.purchasing.tax_id = taxid
      this.setTax()
    },
    async removeOrder (index) {
      var order = this.purchasing.order[index]
      var array = this.purchasing.details.filter(d => d.order_no === order.purchasing_no)
      console.log(array)
      for (let i = 0; i < array.length; i++) {
        if (typeof array[i].id === 'undefined') {
          console.log(array[i].product_no + ' : ' + i)
          this.purchasing.details.splice(0, 1)
        } else {
          await axios.delete(purchasingDetailUrl + '/' + array[i].id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
              var data = {
                date: this.purchasing.purchasing_date,
                product_no: array[i].product_no,
                type: 'all',
                company_no: null
              }
              axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
                .then(response => {
                  console.log(response.data.message)
                })
                .catch(error => {
                  console.log(error)
                  console.log(error.response)
                })
              this.purchasing.details.splice(0, 1)
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
            })
        }
      }
      await this.clearDetailCalc()
      await this.purchasing.order.splice(index, 1)
    },
    async requestEdit (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.purchasing.purchasing_no,
        lock_note: value,
        type: 'purchasing'
      }
      console.log(obj)
      await axios.post(lockUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Success', 'Purchasing has been requested', 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
        })
    },
    async requestVoid (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.purchasing.purchasing_no,
        lock_note: value,
        type: 'purchasing-void'
      }
      console.log(obj)
      await axios.post(lockUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Success', 'Purchasing Delete has been requested', 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
        })
    },
    selectClickQty () {
      var array = this.purchasing.details
      for (let i = 0; i < array.length; i++) {
        if (!this.selectQty === true) {
          array[i].qty = array[i].qty_done
          this.calcRowTotal(i)
        } else {
          array[i].qty = 0
          this.calcRowTotal(i)
        }
      }
    },
    async removeAllDetail () {
      var array = this.purchasing.details
      for (let i = 0; i < array.length; i++) {
        if (typeof array[i].id === 'undefined') {
        } else {
          await axios.delete(purchasingUrl + '/detail/' + array[i].id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response)
            })
            .catch(error => {
              console.log(error.response.data)
            })
        }
      }
      this.purchasing.details = []
    },
    async selectOrderMulti (value) {
      var company = null
      var ordIdx = this.purchasing.order.findIndex(d => d.id === null)
      this.purchasing.order.splice(ordIdx, 1)
      for (let a = 0; a < value.length; a++) {
        this.purchasing.order.push(value[a])
        // warehouse = this.warehouseList.find(d => d.company_no === value[a].company_no)
        company = value[a].company_no
        var array = value[a].details
        for (let i = 0; i < array.length; i++) {
          var qtyDone = array[i].qty === '' || array[i].qty === null ? 0 : parseFloat(array[i].qty - array[i].qty_done)
          var uomList = []
          var body = {
            product_no: array[i].product_no
          }
          await axios.post(productUrl + '/uom/list', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              uomList = response.data.data
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
            })
          if (qtyDone > 0) {
            var obj = {
              purchasing_no: this.purchasing_no,
              purchasing_date: this.purchasing_date,
              branch_no: this.purchasing.branch_no,
              product_no: array[i].product_no,
              description: array[i].product,
              qty: 0,
              qty_done: qtyDone,
              uom_id: array[i].uom_id,
              price: array[i].price,
              tax_id: array[i].tax_id,
              tax: array[i].tax,
              discount: array[i].discount,
              discount_percentage: array[i].discount_percentage,
              subtotal: 0,
              total: 0,
              order_no: array[i].purchasing_no,
              state: 'create',
              edit: false,
              uomList: uomList
            }
            await this.purchasing.details.push(obj)
          }
        }
      }
      var arr = this.purchasing.details
      for (let z = 0; z < arr.length; z++) {
        if (arr[z].product_no === null) {
          this.purchasing.details.splice(z, 1)
        }
      }
      await this.setTax()
      this.purchasing.company_no = company
    },
    getVendorOrder () {
      var vendorNo = this.purchasing.vendor_no
      if (vendorNo === null || vendorNo === '') {
        this.$swal(
          'Error',
          'Pilih vendor terlebih dahulu',
          'error'
        )
        return false
      }
      var payload = {
        vendor_no: this.purchasing.vendor_no
      }
      this.$store.dispatch('getVendorOrderList', payload)
    },
    getOrderNo (index) {
      var order = this.purchasing.order[index]
      var payload = {
        purchasing_no: order.purchasing_no
      }
      // console.log(payload)
      this.$store.dispatch('getPurchasingOrderByNo', payload)
    },
    getInventoryNo (index) {
      var inv = this.purchasing.inventory[index]
      var payload = {
        inventory_no: inv.inventory_no
      }
      console.log(payload)
      this.$store.dispatch('getInventoryByNo', payload)
    },
    selectProductToInventory (product) {
      if (this.searchQueryOrder === null || this.searchQueryOrder === '') {
        this.searchQueryOrder = product
        this.card1 = 'col-md-8'
        this.card2 = 'col-md-4'
      } else if (this.searchQueryOrder === product) {
        if (this.searchQueryOrder !== product) {
          this.searchQueryOrder = ''
        } else {
          this.searchQueryOrder = ''
        }
        this.card1 = 'col-md-12'
        this.card2 = null
      }
    },
    async postJournal () {
      var array = this.purchasing.journals
      var loop = []
      for (let i = 0; i < array.length; i++) {
        if (array[i].level === 1) {
          var obj = {
            id: array[i].id
          }
          loop.push(obj)
        }
      }
      this.dataPostJournal = {
        journal: loop
      }
      await axios.post(salesUrl + '/journal/post-collection', this.dataPostJournal, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClickID', this.purchasing.id)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            error
          )
        })
    },
    async approve () {
      await this.$Progress.start()
      this.loader.isLoading = true
      var obj = {
        id: this.purchasing.id
      }
      var resp = {
        error: false,
        message: null
      }
      await axios.post(purchasingUrl + '/approve', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.syncInventory()
      await this.syncOrderAll('no reply')
      await this.syncCOGSAll()
      await this.setJournal()
      if (resp.error === false) {
        await this.$Progress.finish()
        this.loader.isLoading = false
        await this.$swal('Success', resp.message, 'success')
        await this.$emit('backSaveChild')
      }
    },
    async setQtyTotal (code) {
      var d = new Date()
      var n = d.getFullYear()
      var n1 = n - 1
      this.year = [n1, n]
      var newYear = d.getFullYear()
      var newMonth = d.getMonth() + 1
      var newDate = d.getDate()
      var newSetDate = newYear + '-' + newMonth + '-' + newDate
      var comNo = this.purchasing.company_no

      await axios.get(setQtyTotalUrl + '?end=' + newSetDate + '&available=true&company_no=' + comNo + '&product_no=' + code, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async syncCOGSAll (reply) {
      var array = this.purchasing.details
      for (let i = 0; i < array.length; i++) {
        var data = {
          date: this.purchasing.purchasing_date,
          product_no: array[i].product_no,
          type: 'all',
          company_no: this.purchasing.company_no
        }
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log('Success Sync COGS ALL')
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
          })
      }
      if (reply === 'reply') {
        await this.$swal('Success', 'Success SYNC COGS', 'success')
      }
    },
    async syncCOGS () {
      var array = this.purchasing.details
      for (let i = 0; i < array.length; i++) {
        var data = {
          date: this.purchasing.purchasing_date,
          product_no: array[i].product_no,
          type: 'purchasing',
          company_no: this.purchasing.company_no
        }
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log('Success Sync COGS')
            this.$swal('Success', response.data.message, 'success')
          })
          .catch(error => {
            console.log(error.response)
          })
      }
    },
    removePayment (index) {
      var purch = this.getPaymentDetail[index]
      if (purch.id) {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(purchasingUrl + '/payment/' + purch.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                this.getPaymentDetail.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      } else {
        this.purchasing.payment.splice(index, 1)
      }
    },
    addPaymentLine () {
      var obj = {
        payment_no: null,
        purchasing_no: null,
        payment_date: null,
        price: '0',
        method_id: null,
        type_id: null,
        bank_id: null,
        notes: null
      }
      this.purchasing.payment.push(obj)
    },
    setJournalPayment: function () {
      axios.get(purchasingUrl + '/journal/payment/' + this.purchasing.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Create Journal',
            response.data.message,
            'success'
          )
          this.$emit('backClickID', this.purchasing.id)
        })
        .catch(error => {
          console.log(error)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async setJournal (reply) {
      if (this.settingJournal) {
        var resp = {
          error: false,
          message: null
        }
        await axios.get(purchasingUrl + '/journal/' + this.purchasing.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            resp = {
              error: false,
              message: response.data.message
            }
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
        if (reply === 'reply') {
          this.$swal('Create Journal', resp.message, 'success')
          this.$emit('backClickID', this.purchasing.id)
        }
      }
    },
    async setProduct (index) {
      var no = 0
      if (this.purchasing.details[0].id === null) {
        no = index + 1
      } else {
        no = index
      }
      var product = this.productListSelect.find(d => d.product_no === this.purchasing.details[no].product_no)
      this.purchasing.details[no].description = product.product_name
      this.purchasing.details[no].price = product.cost === null ? '0' : product.cost
      var body = {
        product_no: product.product_no
      }
      await axios.post(productUrl + '/uom/list', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.purchasing.details[no].uomList = response.data.data
          this.purchasing.details[no].uom_id = product.uom_id
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    calcRowGroup (index) {
      var qty = this.groupDetail[index].qty
      var qtyDone = this.groupDetail[index].qty_done
      if (parseFloat(qty) > parseFloat(qtyDone)) {
        this.groupDetail[index].qty = qtyDone
        this.$swal('Error', 'Quantity cannot greater than order', 'error')
        return false
      }
      var amount = parseFloat(this.groupDetail[index].price.toString().replace(/\./g, ''))
      var discountPercentage = parseFloat(this.groupDetail[index].discount_percentage)
      var discount = amount * discountPercentage / 100
      var subtotal = amount - discount
      var dpp = 0
      var taxAmount = 0
      var tax = this.taxList.find(d => d.id === this.purchasing.tax_id)
      if (tax.include === false) {
        taxAmount = subtotal * tax.amount / 100
        dpp = subtotal
      } else {
        if (tax.amount === '0') {
          taxAmount = 0
          dpp = subtotal
        } else {
          if (tax.amount === '11') {
            dpp = subtotal / 1.11
            taxAmount = subtotal - dpp
          } else {
            dpp = subtotal / 1.1
            taxAmount = subtotal - dpp
          }
        }
      }
      this.groupDetail[index].discount = discount.toString()
      this.groupDetail[index].subtotal = Math.round(dpp)
      this.groupDetail[index].tax = Math.round(taxAmount)
      this.groupDetail[index].tax_id = this.purchasing.tax_id
      this.groupDetail[index].total = (Math.round(dpp) + Math.round(taxAmount)) * qty

      this.purchasing.discount = this.totalDetailDiscount
      this.purchasing.subtotal = this.totalDetailSubtotal
      this.purchasing.tax = this.totalDetailTax
      this.purchasing.total = this.totalDetail
    },
    calcRowTotal: function (index) {
      var qty = this.purchasing.details[index].qty
      var qtyDone = this.purchasing.details[index].qty_done
      var orderData = this.purchasing.order.filter(d => d.id !== null)
      if (orderData.length > 0) {
        if (parseFloat(qty) > parseFloat(qtyDone)) {
          this.purchasing.details[index].qty = qtyDone
          this.$swal('Error', 'Quantity cannot greater than order', 'error')
          return false
        }
      }
      var amount = parseFloat(this.purchasing.details[index].price.toString().replace(/\./g, ''))
      var discountPercentage = 0
      var discount = 0
      if (this.settingDiscount === false) {
        discount = parseFloat(this.purchasing.details[index].discount.toString().replace(/\./g, ''))
        console.log('setting discount false: ' + discount)
        discountPercentage = parseFloat((discount / amount) * 100)
        this.purchasing.details[index].discount_percentage = discountPercentage
      } else {
        discountPercentage = parseFloat(this.purchasing.details[index].discount_percentage)
        discount = amount * discountPercentage / 100
      }
      var subtotal = amount - discount
      var dpp = 0
      var taxAmount = 0
      var tax = this.taxList.find(d => d.id === this.purchasing.tax_id)
      if (tax.include === false) {
        taxAmount = subtotal * tax.amount / 100
        dpp = subtotal
      } else {
        if (tax.amount === '0') {
          taxAmount = 0
          dpp = subtotal
        } else {
          if (tax.amount === '11') {
            dpp = subtotal / 1.11
            taxAmount = subtotal - dpp
          } else {
            dpp = subtotal / 1.1
            taxAmount = subtotal - dpp
          }
        }
      }
      this.purchasing.details[index].discount = discount.toString()
      this.purchasing.details[index].tax_id = this.purchasing.tax_id
      if (this.settingTaxRound) {
        this.purchasing.details[index].subtotal = Math.round(dpp)
        this.purchasing.details[index].tax = Math.round(taxAmount)
        this.purchasing.details[index].total = (Math.round(dpp) + Math.round(taxAmount)) * qty
      } else {
        this.purchasing.details[index].subtotal = dpp
        this.purchasing.details[index].tax = taxAmount
        this.purchasing.details[index].total = Math.round((dpp + taxAmount) * qty)
      }
      // this.purchasing.details[index].subtotal = Math.round(dpp)
      // this.purchasing.details[index].tax = Math.round(taxAmount)
      // this.purchasing.details[index].total = (Math.round(dpp) + Math.round(taxAmount)) * qty
      this.purchasing.discount = this.totalDetailDiscount
      this.purchasing.subtotal = this.totalDetailSubtotal
      this.purchasing.tax = this.totalDetailTax
      this.purchasing.total = this.totalDetail
    },
    setDiscountTotal: function () {
      var sum = 0
      var array = this.purchasing.details
      for (let i = 0; i < array.length; i++) {
        var discount = parseFloat(array[i].discount.toString().replace(/\./g, ''))
        var qty = array[i].qty
        sum += qty * discount
      }
      this.purchasing.discount = sum
    },
    setTaxTotal: function () {
      var sum = 0
      var array = this.purchasing.details
      for (let i = 0; i < array.length; i++) {
        var tax = parseFloat(array[i].tax)
        var qty = array[i].qty
        sum += qty * tax
      }
      this.purchasing.tax = sum
    },
    selectInventory: function (value) {
      var pod = this.purchasing.details.filter(d => d.id !== null)
      console.log('length ' + pod.length)
      this.purchasing.ref_no = value.inventory_no
      if (pod.length === 0) {
        this.purchasing.details = []
        var array = value.details
        for (let i = 0; i < array.length; i++) {
          console.log(array[i])
          var price = array[i].cost === null ? 0 : parseFloat(array[i].cost)
          var total = '0'
          if (price === 0) {
            total = '0'
          } else {
            total = parseFloat(array[i].qty) * price
            total = total.toString()
          }
          if (this.purchasing.purchasing_no === null) {
            var obj = {
              purchasing_no: null,
              purchasing_date: null,
              branch_no: null,
              product_no: array[i].product_no,
              product: array[i].description,
              description: array[i].description,
              qty: array[i].qty,
              qty_done: array[i].qty,
              uom_id: array[i].uom_id,
              price: array[i].cost === null ? '0' : array[i].cost.toString(),
              tax_id: null,
              tax: '0',
              discount: '0',
              total: total,
              uomList: this.uomList,
              edit: false
            }
            this.purchasing.details.push(obj)
          } else if (this.purchasing.purchasing_no !== null) {
            console.log(array[i].product_no)
            console.log(this.purchasing.details)
            var po = this.purchasing.details.find(d => d.product_no === array[i].product_no)
            console.log(po)
            if (po) {
              po.qty_done = array[i].qty
            }
          }
        }
      } else {
        var array2 = value.details
        var pDetail = this.purchasing.details
        for (let a = 0; a < array2.length; a++) {
          for (let z = 0; z < pDetail.length; z++) {
            if (array2[a].product_no === pDetail[z].product_no) {
              pDetail[z].qty_done = array2[a].qty
            }
          }
        }
      }
    },
    selectInventoryMulti (value) {
      var pod = this.purchasing.details.filter(d => d.id !== null)
      this.purchasing.inventory = value
      if (pod.length === 0) {
        this.purchasing.details = []
        for (let i = 0; i < value.length; i++) {
          var array = value[i].details
          for (let a = 0; a < array.length; a++) {
            var price = array[a].cost === null ? 0 : parseFloat(array[a].cost)
            var total = '0'
            if (price === 0) {
              total = '0'
            } else {
              total = parseFloat(array[a].qty) * price
              total = total.toString()
            }
            if (this.purchasing.purchasing_no === null) {
              var obj = {
                purchasing_no: null,
                purchasing_date: null,
                branch_no: null,
                product_no: array[a].product_no,
                product: array[a].description,
                description: array[a].description,
                qty: array[a].qty,
                qty_done: array[a].qty,
                uom_id: array[a].uom_id,
                price: price.toString(),
                tax_id: null,
                tax: '0',
                discount: '0',
                total: total,
                uomList: this.uomList,
                edit: false
              }
              this.purchasing.details.push(obj)
            } else if (this.purchasing.purchasing_no !== null) {
              var po = this.purchasing.details.find(d => d.product_no === array[a].product_no)
              if (po) {
                po.qty_done = array[a].qty
              }
            }
          }
        }
      } else {
        for (let b = 0; b < value.length; b++) {
          var array2 = value[b].details
          var pDetail = this.purchasing.details
          var qtyDone = 0
          for (let a = 0; a < array2.length; a++) {
            for (let b = 0; b < pDetail.length; b++) {
              if (pDetail[b].product_no === array2[a].product_no) {
                qtyDone += parseFloat(array2[a].qty)
                pDetail[b].qty_done = qtyDone.toString()
              }
            }
          }
        }
      }
    },
    purchasingPayment: function () {
      this.$emit('onPayment', this.purchasing)
    },
    createInventory: function () {
      const obj = {
        purchasing_no: this.purchasing.purchasing_no
      }
      axios.post(inventoryUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
          if (error.response.data) {
            this.$swal(
              'Error',
              error.response.data.message,
              'error'
            )
          } else {
            this.$swal(
              'Error',
              '<pre>' + error.response.data + '</pre>',
              'error'
            )
          }
        })
    },
    setTax: function () {
      var array = this.purchasing.details
      for (let i = 0; i < array.length; i++) {
        this.calcRowTotal(i)
      }
    },
    detailClear: function () {
      var array = this.purchasing.details
      for (let i = 0; i < array.length; i++) {
        // array[i].edit = false
      }
    },
    backParent: function () {
      this.alert = []
      this.$emit('backClicked')
    },
    async clearDetailCalc () {
      var array = this.purchasing.details
      for (let i = 0; i < array.length; i++) {
        this.calcRowTotal(i)
      }
    },
    async updatePurchasing () {
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.clearDetailCalc()
      var data = {
        id: this.purchasing.id,
        purchasing_no: this.purchasing.purchasing_no,
        purchasing_date: this.purchasing.purchasing_date,
        purchasing_due_date: this.purchasing.purchasing_due_date,
        ref_no: this.purchasing.ref_no,
        branch_no: this.purchasing.branch_no,
        vendor_no: this.purchasing.vendor_no,
        subtotal: this.purchasing.subtotal,
        tax_id: this.purchasing.tax_id,
        tax: this.purchasing.tax,
        discount: this.purchasing.discount,
        total: this.purchasing.total,
        delivery_cost: this.purchasing.delivery_cost,
        deliver_no: this.purchasing.deliver_no,
        status: this.purchasing.status,
        type_id: this.purchasing.type_id,
        lock: this.purchasing.lock,
        company_no: this.purchasing.company_no,
        term_due_id: this.purchasing.term_due_id,
        ext_no: this.purchasing.ext_no,
        sp_no: this.purchasing.sp_no,
        discount_percentage: this.purchasing.discount_percentage,
        schedule_payment_date: this.purchasing.schedule_payment_date,
        notes: this.purchasing.notes,
        deliver_date: this.purchasing.deliver_date,
        faktur_no: this.purchasing.faktur_no,
        faktur_date: this.purchasing.faktur_date,
        details: this.dataDetailCollect,
        order: this.purchasing.order
      }
      var resp = {
        error: false,
        message: null
      }
      console.log('update purchasing')
      console.log(data)
      await axios.put(purchasingUrl + '/' + this.purchasing.id, data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          this.$Progress.fail()
          this.loader.isLoading = false
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      if (resp.error === false) {
        await this.$Progress.start()
        this.loader.isLoading = false
        await this.$swal('Purchasing', resp.message, 'success')
        await this.$emit('backClickID', this.purchasing.id)
        await this.$swal('Purchasing', 'Process Inventory & HPP?', 'success')
        await this.syncInventory()
        await this.syncOrderAll('no reply')
        await this.syncCOGSAll()
        await this.setJournal()
        if (this.alert.length > 0) {
          await this.$emit('backClickID', this.purchasing.id)
        } else {
          await this.$emit('backSaveChild')
          this.alert = []
        }
      }
    },
    async createPurchasing () {
      this.validate()
      if (this.alert.length > 0) {
        await window.scrollTo(0, 0)
        await this.$swal('Validation', 'Data Order Belum valid, cek inputan terlebih dahulu', 'error')
        return false
      }
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.clearDetailCalc()
      var data = {
        id: this.purchasing.id,
        purchasing_no: this.purchasing.purchasing_no,
        purchasing_date: this.purchasing.purchasing_date,
        purchasing_due_date: this.purchasing.purchasing_due_date,
        ref_no: this.purchasing.ref_no,
        branch_no: this.purchasing.branch_no,
        vendor_no: this.purchasing.vendor_no,
        subtotal: this.purchasing.subtotal,
        tax_id: this.purchasing.tax_id,
        tax: this.purchasing.tax,
        discount: this.purchasing.discount,
        total: this.purchasing.total,
        delivery_cost: this.purchasing.delivery_cost,
        deliver_no: this.purchasing.deliver_no,
        status: 'open',
        type_id: this.purchasing.type_id,
        lock: false,
        company_no: this.purchasing.company_no,
        term_due_id: this.purchasing.term_due_id,
        ext_no: this.purchasing.ext_no,
        sp_no: this.purchasing.sp_no,
        discount_percentage: this.purchasing.discount_percentage,
        schedule_payment_date: this.purchasing.schedule_payment_date,
        notes: this.purchasing.notes,
        deliver_date: this.purchasing.deliver_date,
        faktur_no: this.purchasing.faktur_no,
        faktur_date: this.purchasing.faktur_date,
        details: this.dataDetailCollect,
        order: this.purchasing.order
      }
      var resp = {
        error: false,
        message: null
      }
      var purchase = []
      console.log(purchase)
      console.log(data)
      await axios.post(purchasingUrl, data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
          purchase = response.data.data
          console.log(response.data.data)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.fail()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      if (resp.error === false) {
        await this.$Progress.finish()
        this.loader.isLoading = false
        await this.$swal('Purchasing', resp.message, 'success')
        await this.$emit('backClickID', purchase.id)
        await this.$swal('Purchasing', 'Process Inventory & HPP?', 'success')
        await this.syncInventory()
        await this.syncOrderAll('no reply')
        await this.syncCOGSAll()
        await this.setJournal()
        if (this.alert.length > 0) {
          await this.$emit('backClickID', purchase.id)
        } else {
          await this.$emit('backSaveChild')
          this.alert = []
        }
      }
    },
    validate () {
      this.alert = []
      var extNo = this.purchasing.ext_no === null ? null : this.purchasing.ext_no.trim()
      if (extNo === null || extNo === '') {
        this.alert.push({
          message: '<b>Invoice No.</b> harus diinput terlebih dahulu'
        })
      }
      var order = this.purchasing.order.filter(d => d.id !== null)
      if (order.length === 0) {
        this.alert.push({
          message: '<b>Order</b> masih kosong'
        })
      }
      var total = parseFloat(this.purchasing.total)
      if (total === 0) {
        this.alert.push({
          message: '<b>Total</b> masih kosong, cek kembali inputan product'
        })
      }

      if (this.purchasing.vendor_no === null) {
        this.alert.push({
          message: '<b>Vendor</b> harus diinput terlebih dahulu'
        })
      }

      if (this.purchasing.tax_id === null) {
        this.alert.push({
          message: '<b>Tax</b> harus diinput terlebih dahulu'
        })
      }
      var array = this.purchasing.details
      var result = []
      var resultProductNo = []
      var resultProductUom = []
      array.reduce(function (res, value) {
        // Check product_no null & duplicate
        if (value.product_no !== null) {
          var price = value.price.replace(/\./g, '')
          var key = value.product_no + price + value.order_no
          console.log(key)
          if (!res[key]) {
            res[key] = {
              id: key,
              product_no: value.product_no,
              price: parseFloat(price).toLocaleString('id-ID')
            }
          } else {
            result.push({
              id: key,
              product_no: value.product_no,
              price: parseFloat(price).toLocaleString('id-ID')
            })
          }
          // check uom null
          if (value.uom_id === null) {
            resultProductUom.push({
              id: value.id + 'uom',
              product_no: value.product_no
            })
          }
          if (value.product_no === null) {
            resultProductNo.push({
              id: res
            })
          }
        } else {
          resultProductNo.push({
            id: res
          })
        }
        return res
      }, {})

      if (result.length > 0) {
        for (let i = 0; i < result.length; i++) {
          this.alert.push({
            message: 'Duplicate Product & Price (<b>' + result[i].product_no + ' | ' + result[i].price + '</b>)'
          })
        }
      }
      if (resultProductUom.length > 0) {
        for (let z = 0; z < resultProductUom.length; z++) {
          this.alert.push({
            message: '<b>Uom</b> cannot be null ' + resultProductUom[z].product_no
          })
        }
      }
      if (resultProductNo.length > 0) {
        var msg = {}
        for (let h = 0; h < resultProductNo.length; h++) {
          msg = {
            message: '<b>Product</b> harus diinput terlebih dahulu (tidak boleh kosong)'
          }
        }
        this.alert.push(msg)
      }
    },
    addNewLine: function () {
      this.purchasing.details.push({
        purchasing_no: null,
        purchasing_date: null,
        branch_no: null,
        product_no: null,
        description: null,
        qty: 1,
        qty_done: null,
        uom_id: null,
        price: '0',
        tax_id: this.purchasing.tax_id,
        tax: '0',
        discount: '0',
        discount_percentage: '0',
        total: '0',
        subtotal: '0',
        state: 'create',
        order_no: null,
        edit: false,
        uomList: [{
          id: null,
          name: null,
          category_id: null,
          type_id: null,
          ratio: null,
          active: null
        }]
      })
      this.state = 'create'
    },
    editDetail: function (id) {
      // var p = this.purchasing.details.find(d => d.id === id)
      this.idDetail = id
    },
    async removeDetail (index) {
      var detail = this.purchasing.details[index]
      var orderNo = detail.order_no
      if (typeof detail.id === 'undefined') {
        this.purchasing.details.splice(index, 1)
      } else {
        await this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(purchasingDetailUrl + '/' + detail.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                console.log(response.data.message)
                var data = {
                  date: this.purchasing.purchasing_date,
                  product_no: detail.product_no,
                  type: 'all',
                  company_no: null
                }
                console.log(data)
                axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
                  .then(response => {
                    console.log(response.data.message)
                  })
                  .catch(error => {
                    console.log(error)
                    console.log(error.response)
                  })
                this.purchasing.details.splice(index, 1)
                var orderDetail = this.purchasing.details.filter(d => d.order_no === orderNo)
                if (orderDetail.length === 0) {
                  const orderID = this.purchasing.order.findIndex(d => d.purchasing_no === orderNo)
                  this.purchasing.order.splice(orderID, 1)
                }
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
              })
          }
        })
      }
    },
    selectProduct: function (data) {
      var detail = this.purchasing.details.find(d => d.id === data.id)
      detail.total = data.total
      // detail.price =  data.price.replace(/\./g, '')
      // detail.total = data.total
    },
    async goDispatch (date) {
      var payload = {
        date: date
      }
      this.$store.dispatch('getProductWithTotal', payload)
    },
    async syncInventory () {
      var wh = this.warehouseList.find(d => d.company_no === this.purchasing.company_no)
      var loop = []
      var array = this.purchasing.details
      for (let i = 0; i < array.length; i++) {
        var price = parseFloat(array[i].price.replace(/\./g, ''))
        var discount = parseFloat(array[i].discount)
        var cost = price - discount
        console.log(price + ' >< ' + discount)
        var obj = {
          inventory_no: null,
          qty_demand: array[i].qty,
          qty_done: array[i].qty,
          serial_number: null,
          product_no: array[i].product_no,
          product_sku: null,
          warehouse_no: wh ? wh.warehouse_no : null,
          uom_id: array[i].uom_id,
          inventory_date: this.purchasing.purchasing_date,
          branch_no: this.purchasing.branch_no,
          expired_date: null,
          status: null,
          sec_serial_number: null,
          internal_no: null,
          company_no: this.purchasing.company_no,
          cost: cost,
          vendor_no: this.purchasing.vendor_no,
          receive_finish: true
        }
        loop.push(obj)
      }
      this.inventoryData = {
        id: null,
        inventory_no: null,
        type_id: 'regular',
        inventory_date: this.purchasing.deliver_date == null ? this.purchasing.purchasing_date : this.purchasing.deliver_date,
        purchasing_no: this.purchasing.purchasing_no,
        warehouse_no: wh ? wh.warehouse_no : null,
        status: null,
        ext_no: this.purchasing.ext_no,
        branch_no: this.purchasing.branch_no,
        company_no: this.purchasing.company_no,
        user_id: null,
        user_approve: null,
        lock: false,
        vendor_no: this.purchasing.vendor_no,
        ext_no2: null,
        details: loop
      }
      console.log('syncInventory')
      console.log(this.inventoryData)
      await axios.post(purchasingUrl + '/inventory/sync', this.inventoryData, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
</style>
